cv.idealTextColor = function(bgColor) {
  if(_.isUndefined(bgColor)){
    return '';
  }

   var nThreshold = 89;
   var components = cv.getRGBComponents(bgColor);
   var bgDelta = (components.R * 0.299) + (components.G * 0.587) + (components.B * 0.114);

   return ((255 - bgDelta) < nThreshold) ? "-text-dark -border-dark" : "-text-light -border-light";
};

cv.getTextColor = function(bgColor) {
  if(_.isUndefined(bgColor)){
    return '';
  }

  var nThreshold = 89;
  var components = cv.getRGBComponents(bgColor);
  var bgDelta = (components.R * 0.299) + (components.G * 0.587) + (components.B * 0.114);

  return ((255 - bgDelta) < nThreshold) ? "#000000" : "#ffffff";
};
